export const convertNumber = (number: number) => {
  if(isNaN(number)) return 
  if (number === null) return 0;

  return number.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
